<template>
    <a-modal
    class="billInfo-refund"
    title="订单退款"
    v-model="visibleRefund"
    @cancel="closeRefund"
    :width="1000"
    :destroyOnClose="true">
        <a-row class="mb16">
            <a-col :span="8">订单状态：{{orderData.tradeState}}</a-col>
            <a-col :span="8">交易订单号：{{refundData.transNo}}</a-col>
        </a-row>
        <a-row class="mb16">
            <a-col :span="8">购买者手机号：{{refundData.phone}}</a-col>
            <a-col :span="8">购买者名称：{{refundData.account || '-'}}</a-col>
            <a-col :span="8">下单时间：{{refundData.transTime}}</a-col>
        </a-row>
        <a-divider class="mt16 mb16"></a-divider>
        <p class="mb24">退款商品选择</p>
        <a-table
        bordered
        :dataSource="refundData.refundListDetail"
        :columns="columns1"
        :pagination="false"
        :defaultExpandAllRows="true"
        :expandIconColumnIndex="-1"
        :scroll="{y:300}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps}"
        :rowKey="(record, index) => record.key"
        >
            <span slot="businessId" slot-scope="businessId">{{businessId || "-"}}</span>
            <span slot="ticketStateStr" slot-scope="ticketStateStr, row">{{ticketStateStr || row.statusStr || "-"}}</span>
            <span slot="goodsName" slot-scope="goodsName, row">{{row.isBonus ? '【加赠】' : row.isGift ? '【赠】' : ''}}{{goodsName}}</span>
            <span slot="refundReduce" slot-scope="text,record">{{$utils.toReduce(record.payAmount - record.refundAmount, 2)}}</span>
            <span slot="amount" slot-scope="amount">{{$utils.toFixed(amount, 2)}}</span>
            <template slot="action" slot-scope="text,record">
                <a-input-number :disabled="Boolean(record.isGift) || Boolean(record.isNotRefund)" :min="0" :max="Number($utils.toFixed(record.payAmount - record.refundAmount, 2))" :precision="2" placeholder="请输入" v-model="record.applyRefundAmount" />
            </template>
        </a-table>
        <div class="mt16 border-gray">
            <a-row>
                <a-col :span="12">
                    <div style="color: #000">支付信息</div>
                </a-col>
            </a-row>
            <a-divider class="mt16 mb16"></a-divider>
            <a-row class="mb16">
                <a-col class="red" :span="12">收银台优惠使用：{{refundData.discountName || '--'}}</a-col>
                <a-col class="red" :span="12">收银台优惠抵扣金额：{{refundData.discountAmount || 0}} 元</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col class="red" :span="12">优惠券使用：{{refundData.couponName || '--'}}</a-col>
                <a-col class="red" :span="12">优惠券抵扣金额：{{refundData.couponAmount || 0}} 元</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col class="red" :span="12">实收金额/元：{{refundData.payAmount}} 元</a-col>
                <a-col class="red" :span="12">已退金额/元：{{refundData.refundAmount ? refundData.refundAmount : 0}} 元</a-col>
            </a-row>
            <a-row>
                <a-col :span="12">购买途径：{{refundData.platform ? refundData.platform === '收银台' ? refundData.shopName : refundData.platform : '--'}}</a-col>
                <a-col :span="12">支付方式：{{$utils.payMode[refundData.payMode]}}</a-col>
            </a-row>
        </div>
        <a-form :form="formModelRefund" labelAlign="left">
            <div class="border-gray mt16">
                <div class="mb8" style="color: #000">申请说明</div>
                <remark :labelSpan="2" :wrapperSpan="17" :isRemark="false" operateCode="TicketRefund"/>
            </div>
            <div class="border-gray mt16">
                <div class="mb8" style="color: #000">退款审核</div>
                <a-row>
                    <a-col :span="12">
                        <a-form-item label="审核人职位" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                            <a-select v-decorator="['role',{rules:[{required: true, message: '请选择'}]}]" style="width:70%" placeholder="请选择" :labelInValue="true" @change="handleSelectChange">
                                <a-select-option :value="item.id" v-for="item in comfirmRoleList" :key="item.id" >{{item.roleName}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="审核人" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                            <a-select v-decorator="['auditor',{rules:[{required: true, message: '请选择'}]}]" style="width:70%" @change="changeAuditor" placeholder="请选择" :labelInValue="true">
                                <a-select-option :value="item.id" v-for="item in memberList" :key="item.id" >{{item.name}}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>
                <span class="text-fail">*是否发送短信通知由审核人在审核过程中选择</span>
            </div>
        </a-form>
        <div class="text-fail mt16" v-if="refundData.payMode == 3 || refundData.payMode == 4 || (refundData.payMode == 11 && refundData.isManualPayment)">*该笔订单系统无法自动退款。请先在系统内发起“退款”申请，再完成线下退款流程</div>
        <template slot="footer">
            <div>
                <a-button @click="closeRefund">取消</a-button>
                <a-button type="primary" @click="refundSave">确认</a-button>
            </div>
        </template>
    </a-modal>
</template>

<script>

    /**
     * 退款组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visibleRefund 控制退款弹窗是否显示
     *
     * @func closeModalRefund 通知父组件关闭退款弹窗
     */
    import remark from '@/components/modules/platform/remark.component';
    import { mapGetters } from "vuex";
    const columns1 = [
        {
            title: "商品名称",
            dataIndex: "goodsName",
            scopedSlots: { customRender: "goodsName" }
        },
        {
            title: "用户票券id",
            dataIndex: "businessId",
            scopedSlots: { customRender: "businessId" }
        },
        {
            title: "状态",
            dataIndex: "ticketStateStr",
            scopedSlots: { customRender: "ticketStateStr" }
        },
        {
            title: "购买金额",
            dataIndex: "payAmount",
            scopedSlots: { customRender: "amount" }
        },
        {
            title: "已退金额",
            dataIndex: "refundAmount",
            scopedSlots: { customRender: "amount" }
        },
        {
            title: "剩余可退款金额",
            dataIndex: "refundReduce",
            scopedSlots: { customRender: "refundReduce" }
        },
        {
            title: "申请退款金额",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "member-order-refund",
        zh: "退款组件",
        data() {
            return {
                selectedRowKeys: [],
                refundList: [],
                comfirmRoleList: [],
                memberList: [],
                // 退款表头
                columns1,
                visibleRefund: false,
                refundData: {},
            };
        },
        props: {
            detailData: {type: Object},
            orderData: {type: Object},
        },
        components: {
            remark
        },
        computed: {
            ...mapGetters(["shopId", "shopName"]),
        },
        methods: {
            getCheckboxProps(record) {
                return ({
                    props: {
                        disabled: Boolean(record.isGift) || Boolean(record.isNotRefund), // Column configuration not to be checked
                        name: record.goodsName,
                    },
                })
            },
            // 多选选中
            onSelectChange(selectedRowKeys, refundList) {
                this.selectedRowKeys = selectedRowKeys;
                this.refundList = refundList;
            },
            //切换审核人职位下拉时，改变审核人下拉为当前职位下的人
            handleSelectChange(value) {
                // value.key: 职位ID，value.label: 职位name
                this.position = value.key
                this.name = value.label;
                this.comfirmMember();
            },
            //切换审核人
            changeAuditor(value) {
                // value.key: 审核人ID，value.label: 审核人name
                this.auditorId = value.key
                this.auditor = value.label
            },

            // 发起退款
            refundSave() {
                this.formModelRefund.validateFields((err, values) => {
                    if (!err) {
                        const refundList = this.refundList.filter(el => el.applyRefundAmount == 0 || el.applyRefundAmount > 0);
                        const refundData = this.$utils.deepClone(this.refundData);
                        if (!refundList.length) {
                            this.$message.error('请检查：退款票券是否选择，退款金额是否填写')
                            return false
                        }
                        refundList.forEach(el => {
                            el.gifts = el.gifts && el.gifts.filter(i => i.statusStr == "未使用" || i.statusStr == "已生效");
                        });
                        this.confirmLoading = true;
                        delete refundData.orderTickets;
                        delete refundData.refundGoods;
                        delete refundData.refundListDetail;
                        this.$api.order.refundOrderList({
                            body: {
                                ...refundData,
                                refundMode: 0,
                                reason: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                goodsReturn: refundList,
                                auditId: values.auditor.key,
                                auditer: values.auditor.label,
                                account: refundData.phone,
                                shopId: this.shopId,
                            }
                        })
                        .then(res => {
                            this.refundList = [];
                            this.selectedRowKeys = [];
                            this.refundData = {orderTickets: []};
                            this.$message.success('操作成功，可去审核列表查看审核情况')
                            this.visibleRefund = false;
                            this.confirmLoading = false;
                            this.$emit("resetList")
                            this.$eventBus.emit('refreshAutid');
                        })
                        .catch(res => {
                            this.confirmLoading = false
                        })
                    }
                })
            },
            closeRefund() {
                this.formModelRefund.resetFields();
                this.selectedRowKeys = [];
                this.visibleRefund = false;
                this.refundList = [];
            },
            //审核人职位
            comfirmRole() {
                if(!this.shopId) return
                this.$api.audit.sysRoleRefund({
                }).then(res => {
                    this.comfirmRoleList = res;
                });
            },

            //审核人 根据职位筛选
            comfirmMember() {
                if(!this.shopId) return
                this.$api.audit.sysUserRefund({
                    query: {
                        shopId: this.shopId,
                        roleId: this.position
                    }
                }).then(res => {
                    this.memberList = res.filter(i => i.id !== this.loginInfo.id);
                });
            },

        },
        beforeCreate() {
            this.formModelRefund = this.$form.createForm(this);
            this.loginInfo = this.$userInfoTool.getUser();
        },
        created() {},
        updated() {},
        mounted() {
            this.comfirmRole()
        },
        watch: {
            'detailData'(val) {
                val.refundAmount = 0;
                val.refundListDetail = [];
                val.orderTickets && val.orderTickets.forEach((el, index) => {
                    if (el.stateStr == '已关闭' || el.stateStr == '待支付' || el.stateStr == "待付款") {
                        el.closeNavigate = true;
                        el.businessId = el.invalidType = el.residueNum = el.ticketStateStr = el.expireDay = "-";
                    }
                    val.refundListDetail.push(el);
                    el.gifts && val.refundListDetail.push(...el.gifts);
                });

                val.refundListDetail.forEach( (el, index) => {
                    el.isNotRefund = !Boolean(el.residueNum) || Boolean(['isForbidden', 'isFrozen', 'isInvalid', 'isLocked'].find(item => el[item]))
                    el.refundAmount = el.refundAmount || 0;
                    val.refundAmount += el.refundAmount;
                    el.refundCount = 0;
                    el.key = index;
                });
                this.refundData = val;
            },
            'shopId'() {
                this.comfirmRole()
            }
        }
    };
</script>

<style lang="scss">
    .billInfo-refund {
        background-color: #f3f3f3;
        padding: 14px;
        .ant-input {
            width: 80% !important;
            margin-right: 16px;
        }
    }
</style>
